import {
    Box,
    MenuItem,
} from '@mui/material';
import React from 'react';
import HeadTittle from "../../../components/HeadTittle";
import {CustomTextField} from "../../../components/CustomTextField";
import {CustomSelect} from "../../../components/CustomSelect";
import CustomTimePicker from "../../../components/CustomTimePicker";
import {CustomDatePicker} from "../../../components/CustomDatePicker";
import {CustomSelectAndChildren} from "../../../components/CustomSelectAndChildren";
import {FILE_TYPE} from "../../../Helpers/fileType";
import routes from '../../../Routes/routes';
import DivContainerBody from "../../../components/DivContainerBody";
import {CustomAntSwitch} from "../../../components/CustomAntSwitch";
import CreateNotificationsApp from "./NotificationPanel/Functionality/CreateNotificationsApp";
import {NOTIFICATION_TYPE_MODEL, PEOPLE_MODEL} from "./NotificationPanel/Functionality/NotificationModel";
import DividerWithText from "../../../components/DividerWithText";
import CustomDescriptionLabel from "../../../components/CustomDescriptionLabel";
import EmployeeNotificationCard from "./NotificationPanel/SubComponents/EmployeeNotificationCard";
import ButtonAction from "../../../components/buttons/ButtonAction";
import {AddIcon} from "../../../components/buttons/IconButtons";
import CustomPhotoPicker from '../../../components/PhotoPicker/CustomPhotoPicker';
import {ACTION_MODEL} from '../../../Helpers/ActionModel';
const CreateNotifications = () => {

    const {
        t, // Translation function
        emptyFields,
        title,
        setTitle,
        selectedType,
        setSelectedType,
        message,
        setMessage,
        notificationTypeList,
        time,
        setTime,
        date,
        setDate,
        type,
        setType,
        selectedScope,
        setSelectedScope,
        fileType,
        selectedEmployees,
        employeesData,
        pagination,
        handleCheckBox,
        handleSwitch,
        handleCreate,
        photoPickerFile,
        setPhotoPickerFile,
        photoPickerPdf,
        setPhotoPickerPdf
    } = CreateNotificationsApp();

    return (
        <>
            <HeadTittle name={'create'} link={routes.announcement.list}>
                <ButtonAction
                    id={"btn_cn_create"}
                    name={"create"}
                    className={"btn-icon-add"}
                    onClick={handleCreate}
                    Icon={AddIcon}
                />
            </HeadTittle>

            <DivContainerBody>
                <div className={"row mt-4"}>
                    <div className={"col-12 mb-4"}>
                        <DividerWithText title={t('data')} />
                    </div>
                    <div className="col-sm-12 col-md-6 col-xxl-6 col-lg-6">
                        <CustomTextField id={"slt_cn_title"}
                                         name={"title"}
                                         value={title}
                                         trans={"title"}
                                         type={"text"}
                                         disabled={false}
                                         required={true}
                                         onChange={(e) => setTitle(e.target.value)}
                                         emptyFields={emptyFields}
                        />
                    </div>
                    <div className='col-sm-12 col-md-6 col-xxl-6 col-lg-6 '>
                        <CustomSelect id={"slt_cn_notification_type"}
                                      name={"notificationType"}
                                      value={selectedType}
                                      keyName="id"
                                      onChange={(e) => setSelectedType(e.target.value)}
                                      list={notificationTypeList}
                                      trans={"notificationType"}
                                      label={"lbl_cn_notification_type"}
                                      emptyFields={emptyFields}
                                      required={true}
                                      showNoSelectionOption={false}
                        />
                    </div>
                    {selectedType === NOTIFICATION_TYPE_MODEL.MEETING.id && (
                        <>
                            <div className='col-sm-12 col-md-6 col-xxl-6 col-lg-6 '>
                                <CustomDatePicker id={"dp_cn_date"}
                                                  name={'date'}
                                                  disabled={false}
                                                  onChange={(e) => setDate(e)}
                                                  trans={"date"}
                                                  value={date}
                                                  required={true}
                                                  openTo={"day"}
                                                  disablePast={true}
                                                  emptyFields={emptyFields}

                                />
                            </div>
                            <div className='col-sm-12 col-md-6 col-xxl-6 col-lg-6 '>
                                <CustomTimePicker
                                    title={t('time')}
                                    name='time'
                                    value={time}
                                    handleChange={(newValue) => {
                                        setTime(newValue);
                                    }}
                                    disabled={false}
                                    ampm={false}
                                    inputFormat='HH:mm:ss'
                                    required
                                    id={'tp_cn_time'}
                                    actions={['accept', 'cancel']}
                                    emptyFields={emptyFields}
                                    formatValue={false}
                                />
                            </div>
                        </>
                    )}

                    {selectedType === NOTIFICATION_TYPE_MODEL.OTHER.id && (
                        <div className="col-sm-12 col-md-6 col-xxl-6 col-lg-6">
                            <CustomTextField id={"slt_cn_type"}
                                             name={"type"}
                                             value={type}
                                             trans={"type"}
                                             type={"text"}
                                             disabled={false}
                                             required={true}
                                             onChange={(e) => setType(e.target.value)}
                                             emptyFields={emptyFields}
                            />
                        </div>
                    )}
                    <div className="col-sm-12">
                        <CustomTextField id={"slt_cn_message"}
                                         name={"message"}
                                         value={message}
                                         trans={"message"}
                                         type={"text"}
                                         disabled={false}
                                         required={true}
                                         onChange={(e) => setMessage(e.target.value)}
                                         multiline={true}
                                         length={"MAX"}
                                         emptyFields={emptyFields}
                        />
                    </div>

                    <div className={"col-12 mb-4"}>
                        <DividerWithText title={t('scope')} />
                    </div>

                    <div className='col-sm-12 col-md-6 col-xxl-6 col-lg-6 '>
                        <CustomSelectAndChildren id={"slt_cn_people"}
                                                 name={"people"}
                                                 trans={"people"}
                                                 onChange={(e) => setSelectedScope(e.target.value)}
                                                 value={selectedScope}
                                                 required={true}
                                                 emptyFields={emptyFields}
                                                 showNoSelectionOption={false}
                        >
                            {PEOPLE_MODEL?.getList()?.map((item) => (
                                <MenuItem value={item}>
                                    {t(item)}
                                </MenuItem>
                            ))}
                        </CustomSelectAndChildren>
                    </div>
                </div>

                {selectedScope === PEOPLE_MODEL.CHOOSE_SOME_EMPLOYEES && (
                    <>
                        <div className={"row"}>
                            <div className={"col-12"}>
                                <DividerWithText title={t('employees')} />
                                <CustomDescriptionLabel trans={t("chooseEmployeesToSendIt")}/>
                            </div>
                        </div>
                        <div className={"row"}>
                            {employeesData?.content?.map((item) => (
                                <div className='col-6'>
                                    <EmployeeNotificationCard
                                        checkboxId={"cb_cn_employee_"+ item.id}
                                        item={item}
                                        handleCheckBox={handleCheckBox}
                                        selectedEmployees={selectedEmployees}
                                    />
                                </div>
                            ))}
                        </div>
                        <div className={"row mt-3"}>
                            {pagination()}
                        </div>
                    </>
                )}
                <div className={"row mt-2 mb-4"}>
                    <div className={"col-12"}>
                        <DividerWithText title={t('multimedia')} />
                    </div>
                    <div className="col-12">
                        <CustomAntSwitch id={"sch_cn_file_type"}
                                         name={"fileType"}
                                         checked={fileType}
                                         onChange={handleSwitch}
                                         disabled={false}
                                         transLeft={"imageVideo"}
                                         transRight={"file"}
                        />
                    </div>

                    { fileType ?
                        <Box className={"col-12"}>
                            <CustomPhotoPicker
                                id='fu_cn_file'
                                photoPicker={photoPickerPdf}
                                setPhotoPicker={setPhotoPickerPdf}
                                actionModel={ACTION_MODEL.CREATE}
                                accept={{ ...FILE_TYPE.FILES }}
                                classWith={'w-100'}
                                showPreview={false}
                            />
                        </Box>
                        :
                        <Box className={"col-12"}>
                            <CustomPhotoPicker
                                id='fu_cn_file'
                                photoPicker={photoPickerFile}
                                setPhotoPicker={setPhotoPickerFile}
                                actionModel={ACTION_MODEL.CREATE}
                                accept={{ ...FILE_TYPE.IMAGE_VIDEO }}
                                classWith={'w-100'}
                                showPreview={false}
                            />
                        </Box>
                    }
                </div>
            </DivContainerBody>
        </>
    );
};

export default CreateNotifications;
